export default {
  contractAllTickers: { // 全部合约行情
    url: '/v2/tickers'
  }
};
